import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-[9999] bg-[#0A0D0C] flex items-center justify-center">
      {/* Noise Texture */}
      <div className="absolute inset-0 noise-overlay pointer-events-none" />
      
      {/* Animated Logo */}
      <div className="relative flex flex-col items-center">
        {/* Crown Animation */}
        <motion.div
          initial={{ opacity: 0, y: -20, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <motion.img
            src="/crilam-logo-oval.png"
            alt="CriLam Decorative"
            className="h-28 md:h-36 w-auto"
            animate={{ 
              filter: ['brightness(1)', 'brightness(1.2)', 'brightness(1)']
            }}
            transition={{ 
              duration: 2, 
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </motion.div>
        
        {/* Loading Bar */}
        <motion.div 
          className="mt-8 w-48 h-[2px] bg-white/10 rounded-full overflow-hidden"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <motion.div
            className="h-full bg-[#D4AF37]"
            initial={{ width: '0%' }}
            animate={{ width: '100%' }}
            transition={{ duration: 1.5, ease: "easeInOut" }}
          />
        </motion.div>
        
        {/* Tagline */}
        <motion.p
          className="mt-6 text-white/50 text-sm tracking-[0.3em] uppercase"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
        >
          Premium Manufacturing Excellence
        </motion.p>
      </div>
    </div>
  );
};

export default LoadingScreen;
